<p
  #textParagraph
  [id]="text"
  [innerHtml]="text"
  [class.bold]="bold"
  [class.shadow]="shadow"
  [class.shadow-border]="shadowBorder"></p>
